<template>
    <div class="create-project">
        <b-alert show variant="danger" v-if="companiesLoaded && !companies.length">
            Whoops: no companies were found that are associated with your account.
            Possible reasons:
            <ul>
                <li>You have not been assigned to a company yet</li>
                <li>Your company was disabled by the DOTAG Team</li>
            </ul>
        </b-alert>
        <div class="d-flex justify-content-center mb-3" v-else-if="!companiesLoaded">
            <b-spinner label="Loading..." variant="danger"></b-spinner>
        </div>


        <div v-for="company in companies">
            <h3 v-if="companies.length > 0" class="company-heading">
                {{ company.name}}
                <button v-if="canViewSubscriptions(company)"
                class="company-subscription-button" @click="viewSubscriptions(company)"></button>
            </h3>

<!--            @todo: enable this once payments go live-->
<!--            <template v-if="canViewSubscriptions(company)">-->
<!--                <div v-if="$helpers.isOnGracePeriod(company)"-->
<!--                @click="viewSubscriptions(company)"-->
<!--                class="company-subscription-status" v-text="$helpers.gracePeriodText(company)"-->
<!--                :class="{ 'mod-danger': $helpers.graceDaysLeft(company) < 8 }"></div>-->

<!--                <div v-else-if="!$helpers.isSubscribed(company)"-->
<!--                @click="viewSubscriptions(company)"-->
<!--                class="company-subscription-status" v-text="$helpers.trialPeriodText(company)"-->
<!--                :class="{ 'mod-danger': $helpers.trialDaysLeft(company) < 8 }"></div>-->
<!--            </template>-->

            <div class="row m-1 py-5">
                <div class="col-sm-4 col-lg-3 col-xl-2 my-3 new" v-if="hasManagerPermission('projects.edit', company.id)">
                    <div v-b-modal.project-modal @click="setCompany(company)">
                        <img src="@images/box-iocn.svg" alt="">
                        <h3>Create New Project</h3>
                    </div>
                </div>

                <div v-for="project in projects.filter(item => item.company_id === company.id)"
                     class="col-sm-4 col-lg-3 col-xl-2 my-3 project-card"
                     :class="project.published_at ? 'project-published' : 'project-unpublished'">
                    <a href="javascript:void(0)" @click="goToProjectView(project)">
                        <b-img-lazy v-if="project.image" :src="project.image" alt="" fluid />
                        <b-img-lazy v-else src="/images/default-project-logo.jpg" alt="" fluid />
                        <h3 v-text="project.name"></h3>

                        <template v-if="project.published_at">
                            <p>
                                Published
                                <small class="block" v-text="dateToYMD(project.published_at)"></small>
                            </p>
                        </template>
                        <template v-else>
                            <p>Unpublished</p>
                        </template>
                    </a>
                </div>
            </div>
        </div>

        <ProjectModal :project="project" v-on:projectSaved="projectSaved" v-on:setProject="setProject"></ProjectModal>

    </div>
</template>

<script>
    import axios from 'axios';
    import '@css/settings-create-project.css';
    import ProjectModal from "./parts/ProjectModal";
    import moment from "moment/moment";

    export default {
        components: {ProjectModal},
        data() {

            return {
                project: {
                    name: null,
                    description: null,
                    image: null,
                    address: null,
                    contact_person_phone_number: null,
                    contact_person_name: null,
                    contact_person_email: null,
                    contact_person_address: null,
                    scope: null,
                    assigned_users: []
                },
                companies: [],
                projects: [],
                companiesLoaded: false
            }
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            onLoad(){
                this.$store.dispatch('setProject', null);

                this.$store.dispatch('loadLoggedInUser').then(result => {
                    this.$store.state.user = result;

                    this.$store.dispatch('loadCompanies').then(result => {

                        this.companies = result;
                        this.companiesLoaded = true;

                        if (this.companies.length > 0) {
                            this.$store.state.company.id = this.companies[0].id;
                            this.loadProjects();
                        }

                    });
                });
            },
            loadProjects() {
                let token = this.$store.state.token;

                axios({
                    url: this.$store.getters.apiBase + '/projects',
                    method: 'GET',
                    headers: {"Authorization": "Bearer " + token}
                })
                    .then(response => {
                        this.projects = response.data.data;

                        if(this.projects.length > 0){
                            this.$store.state.project = this.projects[0];
                            this.$store.state.company.id = this.projects[0].company_id;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            projectSaved(){
                this.onCancelProjectCreation();
                this.loadProjects();
            },
            setProject(project){
                this.project = project;
            },

            onCancelProjectCreation() {
                this.project.name = null;
                this.project.description = null;
                this.project.image = null;
                this.step = 0;
            },
            setCompany(company) {
                this.$store.state.company = company;
            },
            viewSubscriptions(company) {
                this.$store.state.company = company;
                this.$store.state.project.user.role = company.role;
                localStorage.company_id = company.id;

                this.$nextTick(function() {
                    this.$router.push({ name: 'company-users-index', params: { company_id: company.id } });
                });
            },
            canViewSubscriptions: function(company) {
                return this.hasManagerPermission('projects.edit', company.id);
            },
            goToProjectView(project){

                localStorage.project_id = project.id;
                localStorage.company_id = project.company_id;

                this.$store.state.company.id = project.company_id;
                this.$store.state.project = project;
                this.$router.push({ name: 'projects-view', params: { id: project.id }});
            },
            dateToYMD(date) {
                return moment(date).format('DD.MM.YYYY HH:mm');
            },
        }
    }
</script>

<style scoped>
.block {
    display: block;
}

.project-card {
    transition: all .2s ease-in-out;

    &:hover {
        transform: scale(1.05);
    }
}

.project-unpublished {
    opacity: .6;

    &:hover {
        opacity: 1;
    }
}
</style>
